<!--
  This icon is from Google Material Symbols
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path
      fill="currentColor"
      d="M12 17.8c1.3 0 2.4-.5 3.3-1.4.9-.9 1.4-2 1.4-3.3s-.5-2.4-1.4-3.3c-.9-.9-2-1.4-3.3-1.4s-2.4.4-3.3 1.3c-.9.9-1.4 2-1.4 3.3s.5 2.4 1.4 3.3c.9 1 2 1.5 3.3 1.5zm0-2.1c-.7 0-1.4-.3-1.9-.8s-.8-1.1-.8-1.9.3-1.4.8-1.9 1.1-.8 1.9-.8 1.4.3 1.9.8.8 1.1.8 1.9-.3 1.4-.8 1.9-1.2.8-1.9.8zm-8.4 5.8c-.6 0-1.1-.2-1.5-.6-.4-.4-.6-.9-.6-1.5V6.8c0-.6.2-1.1.6-1.5.4-.4.9-.6 1.5-.6h3.3l1.9-2.1h6.3L17 4.7h3.3c.6 0 1.1.2 1.5.6.4.4.6.9.6 1.5v12.6c0 .6-.2 1.1-.6 1.5-.4.4-.9.6-1.5.6H3.6zm16.8-2.1V6.8h-4.3l-1.9-2.1H9.8L7.9 6.8H3.6v12.6h16.8z"
    />
  </svg>
</template>
